/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function TrialBalanceInfo({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { rows = [] } = values;

  const handleChangeField = (path, val) => setFieldValue(path, val);

  const handleChangeRow = (index, field, val) => {
    const newRows = [...rows];
    newRows[index][field] = val;
    setFieldValue("rows", newRows);
  };

  // Tự động tính tổng các cột
  useEffect(() => {
    const totals = rows.reduce(
      (acc, row) => {
        acc.totalOpeningDebit += parseFloat(row.openingDebit) || 0;
        acc.totalOpeningCredit += parseFloat(row.openingCredit) || 0;
        acc.totalDebitAmount += parseFloat(row.debitAmount) || 0;
        acc.totalCreditAmount += parseFloat(row.creditAmount) || 0;
        acc.totalClosingDebit += parseFloat(row.closingDebit) || 0;
        acc.totalClosingCredit += parseFloat(row.closingCredit) || 0;
        return acc;
      },
      { totalOpeningDebit: 0, totalOpeningCredit: 0, totalDebitAmount: 0, totalCreditAmount: 0, totalClosingDebit: 0, totalClosingCredit: 0 }
    );

    if (values.totalOpeningDebit !== totals.totalOpeningDebit) setFieldValue("totalOpeningDebit", totals.totalOpeningDebit);
    if (values.totalOpeningCredit !== totals.totalOpeningCredit) setFieldValue("totalOpeningCredit", totals.totalOpeningCredit);
    if (values.totalDebitAmount !== totals.totalDebitAmount) setFieldValue("totalDebitAmount", totals.totalDebitAmount);
    if (values.totalCreditAmount !== totals.totalCreditAmount) setFieldValue("totalCreditAmount", totals.totalCreditAmount);
    if (values.totalClosingDebit !== totals.totalClosingDebit) setFieldValue("totalClosingDebit", totals.totalClosingDebit);
    if (values.totalClosingCredit !== totals.totalClosingCredit) setFieldValue("totalClosingCredit", totals.totalClosingCredit);
  }, [JSON.stringify(rows.map(r => ({
    od: r.openingDebit, oc: r.openingCredit,
    da: r.debitAmount, ca: r.creditAmount,
    cd: r.closingDebit, cc: r.closingCredit,
  })))]);

  const addRow = () => setFieldValue("rows", [...rows, {
    accountCode: "", accountName: "",
    openingDebit: 0, openingCredit: 0,
    debitAmount: 0, creditAmount: 0,
    closingDebit: 0, closingCredit: 0,
  }]);

  const removeRow = (index) => {
    if (rows.length <= 1) return;
    setFieldValue("rows", rows.filter((_, i) => i !== index));
  };

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "14px", lineHeight: "1.5" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "14px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "14px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    th: { border: "1px solid #000", padding: "6px 4px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#fff" },
    td: { border: "1px solid #000", padding: 0, height: "34px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 4px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 4px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "16px" },
    rowLabel: { display: "flex", alignItems: "baseline", gap: "5px", marginBottom: "8px" },
  };

  return (
    <SoftBox style={s.container}>
      {/* HEADER */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
        <div style={{ width: "45%" }}>
          <div style={s.rowLabel}>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.unit} onChange={(e) => handleChangeField("unit", e.target.value)} /></div>
          <div style={s.rowLabel}>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.address} onChange={(e) => handleChangeField("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "55%" }}>
          <div style={{ fontWeight: "bold", fontSize: "16px" }}>Mẫu số S06-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      {/* TITLE */}
      <div style={{ textAlign: "center", margin: "15px 0" }}>
        <h2 style={{ margin: 0, textTransform: "uppercase", fontSize: "18px" }}>BẢNG CÂN ĐỐI SỐ PHÁT SINH</h2>
        <div style={{ marginTop: 8, fontWeight: "bold" }}>
          Tháng <input disabled={containView} style={{ ...s.inputDotted, width: "50px", textAlign: "center" }} value={values.month} onChange={(e) => handleChangeField("month", e.target.value)} />
          {" "}năm <input disabled={containView} style={{ ...s.inputDotted, width: "70px", textAlign: "center" }} value={values.year} onChange={(e) => handleChangeField("year", e.target.value)} />
        </div>
      </div>

      {/* TABLE 8 COLUMNS */}
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px", marginTop: "10px" }}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: "80px" }} rowSpan={2}>Số hiệu tài khoản</th>
              <th style={{ ...s.th, width: "200px" }} rowSpan={2}>Tên tài khoản kế toán</th>
              <th style={s.th} colSpan={2}>Số dư đầu tháng</th>
              <th style={s.th} colSpan={2}>Số phát sinh trong tháng</th>
              <th style={s.th} colSpan={2}>Số dư cuối tháng</th>
              {!containView && <th style={{ ...s.th, width: "40px" }} rowSpan={2}>#</th>}
            </tr>
            <tr>
              <th style={{ ...s.th, width: "110px" }}>Nợ</th>
              <th style={{ ...s.th, width: "110px" }}>Có</th>
              <th style={{ ...s.th, width: "110px" }}>Nợ</th>
              <th style={{ ...s.th, width: "110px" }}>Có</th>
              <th style={{ ...s.th, width: "110px" }}>Nợ</th>
              <th style={{ ...s.th, width: "110px" }}>Có</th>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>B</th>
              <th style={s.th}>1</th>
              <th style={s.th}>2</th>
              <th style={s.th}>3</th>
              <th style={s.th}>4</th>
              <th style={s.th}>5</th>
              <th style={s.th}>6</th>
              {!containView && <th style={s.th}></th>}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx}>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={row.accountCode} onChange={(e) => handleChangeRow(idx, "accountCode", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={row.accountName} onChange={(e) => handleChangeRow(idx, "accountName", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.openingDebit} onChange={(e) => handleChangeRow(idx, "openingDebit", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.openingCredit} onChange={(e) => handleChangeRow(idx, "openingCredit", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.debitAmount} onChange={(e) => handleChangeRow(idx, "debitAmount", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.creditAmount} onChange={(e) => handleChangeRow(idx, "creditAmount", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.closingDebit} onChange={(e) => handleChangeRow(idx, "closingDebit", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.closingCredit} onChange={(e) => handleChangeRow(idx, "closingCredit", e.target.value)} /></td>
                {!containView && <td style={{ ...s.td, textAlign: "center" }}><button type="button" style={s.removeBtn} onClick={() => removeRow(idx)}>–</button></td>}
              </tr>
            ))}

            {/* DÒNG TỔNG CỘNG */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#fafafa" }}>
              <td style={{ ...s.td, textAlign: "center" }}></td>
              <td style={{ ...s.td, padding: "0 8px" }}>Tổng cộng</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(values.totalOpeningDebit)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(values.totalOpeningCredit)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(values.totalDebitAmount)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(values.totalCreditAmount)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(values.totalClosingDebit)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "4px" }}>{fmt(values.totalClosingCredit)}</td>
              {!containView && <td style={s.td}></td>}
            </tr>
          </tbody>
        </table>

        {!containView && (
          <SoftBox textAlign="center" my={2}>
            <SoftButton variant="outlined" color="dark" size="small" onClick={addRow}>+ Thêm tài khoản</SoftButton>
          </SoftBox>
        )}
      </div>

      {/* FOOTER: SIGNATURES */}
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px", textAlign: "center" }}>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Người ghi sổ</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.ledgerClerk} onChange={(e) => handleChangeField("ledgerClerk", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Kế toán trưởng</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.chiefAccountant} onChange={(e) => handleChangeField("chiefAccountant", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "40%" }}>
          <div style={{ fontStyle: "italic", fontSize: "14px", marginBottom: "5px" }}>
            Ngày <input disabled={containView} style={s.inputDottedSmall} value={values.signingDay} onChange={(e) => handleChangeField("signingDay", e.target.value)} /> tháng <input disabled={containView} style={s.inputDottedSmall} value={values.signingMonth} onChange={(e) => handleChangeField("signingMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "50px" }} value={values.signingYear} onChange={(e) => handleChangeField("signingYear", e.target.value)} />
          </div>
          <div style={{ fontWeight: "bold" }}>Người đại diện theo pháp luật</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên, đóng dấu)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "200px", textAlign: "center" }} value={values.legalRepresentative} onChange={(e) => handleChangeField("legalRepresentative", e.target.value)} />
          </SoftBox>
        </div>
      </div> */}
    </SoftBox>
  );
}
